import React from 'react';
import { Links } from '../page_calculator/components/links';

export const PrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <h1>プライバシーポリシー</h1>
      <br />
      <p>
        本サイト（以下、「当サイト」といいます）は、以下の通りプライバシーポリシーを定め、利用者の個人情報の保護に努めます。
      </p>
      <br />

      <h2>1. Google Analytics の利用について</h2>
      <p>
        当サイトでは、サービス向上および利用状況の把握のために Google Analytics
        を使用しています。 Google Analytics は Cookie
        を使用して匿名のトラフィックデータを収集します。
        個人を特定する情報は含まれていません。
        この機能はブラウザの設定で無効にすることが可能です。
      </p>
      <br />

      <h2>2. Google AdSense の利用について</h2>
      <p>
        当サイトでは、第三者配信の広告サービス「Google
        AdSense」を利用しています。 Google
        などの第三者広告配信事業者は、ユーザーの興味に応じた広告を表示するために
        Cookie を使用することがあります。 ユーザーは Google
        の広告設定ページでパーソナライズ広告を無効にすることができます。
      </p>
      <br />

      <h2>3. Cookie の使用について</h2>
      <p>
        Cookie（クッキー）は、ユーザーが当サイトを訪れた際にその端末内に記録される情報です。
        収集される情報には、個人を特定する情報は含まれません。 Cookie
        を使用したくない場合は、ブラウザの設定で無効にできます。
      </p>
      <br />

      <h2>4. 免責事項</h2>
      <p>
        当サイトに掲載されているリンクやバナーなどから他のサイトに移動された場合、移動先サイトで提供される情報、サービス等について一切の責任を負いません。
      </p>
      <br />

      <h2>5. プライバシーポリシーの変更</h2>
      <p>
        本ポリシーは、法令の変更やサイト運営方針の変更により予告なく改定される場合があります。最新の内容は本ページにて常時ご確認いただけます。
      </p>
      <br />
      <Links />
    </div>
  );
};
